import { LeadBannerPlacement, LeadBannerTriggerReason, type LeadBannerTrackingContext } from '../model/leadBanner';

export const MAIN_PAGE_LEAD_BANNER_CONTEXT: LeadBannerTrackingContext = {
  key: LeadBannerPlacement.MainPage,
  placement: LeadBannerPlacement.MainPage,
  position: null,
  triggerReason: LeadBannerTriggerReason.Default,
};

export function getSerpCardLeadBannerContext(cardPosition: number): LeadBannerTrackingContext {
  const position = cardPosition - 1;

  return {
    key: `card:${position}`,
    placement: LeadBannerPlacement.Serp,
    position,
    triggerReason: LeadBannerTriggerReason.Default,
  };
}

export function getSerpNoticeLeadBannerContext(triggerReason: LeadBannerTriggerReason): LeadBannerTrackingContext {
  return {
    key: triggerReason,
    placement: LeadBannerPlacement.Serp,
    position: null,
    triggerReason,
  };
}
